// Dados do evento usados nos links de agenda e de mapa.
// 25/11/2026, das 19h às 23h no horário de Brasília (UTC-3, sem horário de verão).

export const EVENT_TITLE = "GH Experience";
export const EVENT_LOCATION = "Experience House - Rua Gerivatiba, 207, Rooftop, Butantã, São Paulo - SP";
// 25/11/2026 às 19h de Brasília: contagem regressiva da abertura e "Faltam N dias" do convite pessoal.
export const EVENT_TIME = Date.UTC(2026, 10, 25, 22, 0, 0);
const EVENT_START_UTC = "20261125T220000Z";
const EVENT_END_UTC = "20261126T020000Z";

export const MAPS_URL = `https://www.google.com/maps/search/?${new URLSearchParams({
  api: "1",
  query: "Experience House, Rua Gerivatiba, 207, Butantã, São Paulo - SP",
})}`;

// Link "adicionar ao Google Agenda" com o evento preenchido.
export function googleCalendarUrl(details) {
  return `https://calendar.google.com/calendar/render?${new URLSearchParams({
    action: "TEMPLATE",
    text: EVENT_TITLE,
    dates: `${EVENT_START_UTC}/${EVENT_END_UTC}`,
    ctz: "America/Sao_Paulo",
    location: EVENT_LOCATION,
    details,
  })}`;
}

// Escapa texto para campos do iCalendar (RFC 5545).
const icsText = (value) => value.replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/([,;])/g, "\\$1");

// Arquivo .ics (Outlook, Apple Calendar e outros) como data URI para download direto.
export function icsDataUri(details) {
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//GH Solucionador Logistico//GH Experience//PT",
    "CALSCALE:GREGORIAN",
    "METHOD:PUBLISH",
    "BEGIN:VEVENT",
    "UID:ghexperience-2026@ghlogistica.com.br",
    `DTSTAMP:${stamp}`,
    `DTSTART:${EVENT_START_UTC}`,
    `DTEND:${EVENT_END_UTC}`,
    `SUMMARY:${icsText(EVENT_TITLE)}`,
    `LOCATION:${icsText(EVENT_LOCATION)}`,
    `DESCRIPTION:${icsText(details)}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(lines.join("\r\n"))}`;
}
